import { afterNextRender, Component, inject, PLATFORM_ID } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import Swiper from 'swiper';
import { isPlatformBrowser } from '@angular/common';


@Component({
    selector: 'app-key-features',
    templateUrl: './key-features.component.html',
  imports: [
    TranslateModule,
    LottieComponent
  ],
    styleUrls: [
        './../website-grid.scss',
        './../website-pages.scss',
        './key-features.component.scss'
    ]
})
export class KeyFeaturesComponent {
  animations: AnimationOptions[] = [
    {
      path: '/assets/animations/evaluate.json',
    },
    {
      path: '/assets/animations/manage.json',
    },
    {
      path: '/assets/animations/chat.json',
    },
    {
      path: '/assets/animations/statistics.json',
    }
  ];

  platformId = inject(PLATFORM_ID);
  isBrowser = isPlatformBrowser(this.platformId);
  private swiperInstance: Swiper | null = null;
  activeSlideIndex = 0;

  constructor() {
    afterNextRender(() => {
      this.initializeSwiper();
    });
  }

  private initializeSwiper(): void {
    try {
      this.swiperInstance = new Swiper('.features-carousel', {
        slidesPerView: 1.1,
        resizeObserver: false,
        speed: 700,
        allowTouchMove: true,
        spaceBetween: 12,
        breakpoints: {
          960: {
            allowTouchMove: false,
            slidesPerView: 1
          }
        },
        on: {
          slideChange: (swiper) => {
            this.activeSlideIndex = swiper.realIndex;
          }
        }
      });
    } catch (error) {
      console.error('Error initializing Swiper carousel:', error);
    }
  }


  goToSlide(index: number): void {
    if (this.swiperInstance) {
      this.swiperInstance.slideToLoop(index);
    }
  }
}
